import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {
    getIdentityDataView,
    IdentityDataViewContext,
} from "@TKCCP/Store/Data/PunchoutIdentity/PunchoutIdentitySelector";
import updateLoadParameter from "@TKCCP/Store/Pages/PunchoutIdentity/Handlers/UpdateLoadParameter";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationStateTKCCP) => ({
    punchoutDataView: getIdentityDataView(state, state.pagePunchoutIdentity.getPunchoutParameter),
});

const mapDispatchToProps = {
    updateLoadParameter,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PunchoutSecretPaginationStyles {
    wrapper?: InjectableCss;
    pagination?: PaginationPresentationProps;
}

export const paginationStyles: PunchoutSecretPaginationStyles = {
    wrapper: {
        css: css`
            padding: 20px 0;
        `,
    },
};

const styles = paginationStyles;

const PunchoutIdentityPagination: React.FC<Props> = ({ punchoutDataView, updateLoadParameter }) => {
    if (!punchoutDataView.value || !punchoutDataView.pagination) {
        return null;
    }

    const pagination = punchoutDataView.pagination;

    const changePage = (newPageIndex: number) => {
        updateLoadParameter({ page: newPageIndex });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateLoadParameter({ pageSize: newPageSize });
    };

    if (!pagination.totalItemCount) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Pagination
                {...styles.pagination}
                resultsCount={pagination.totalItemCount}
                currentPage={pagination.page}
                resultsPerPage={pagination.pageSize}
                resultsPerPageOptions={pagination.pageSizeOptions}
                onChangePage={changePage}
                onChangeResultsPerPage={changeResultsPerPage}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PunchoutIdentityPagination),
    definition: {
        group: "Order History",
        displayName: "Punchout Identity Pagination",
        // allowedContexts: [MyListsPageContext],
    },
};

export default widgetModule;
